export default __webpack_public_path__ + "static/media/icon-2.ff91f2ff.png";